import { signIn, SignInOptions } from 'next-auth/react';
import { setSessionStorageItem } from 'src/services/storage/session';
import { AUTH_EVENT_TYPES } from '../../../events/constants';
import { dispatch } from '../../../events/dispatch';
import { trackFrequency } from './utils/trackFrequency';
import { FREQUENCY_TRACKED_EVENTS } from './utils/trackFrequency/constants';
import {
    MINIMUM_EXPECTED_FREQUENCY_SINCE_LAST_SIGN_IN,
    LOCATION_REQUESTED_SESSION_STORAGE_KEY,
    SUPPORTED_LOGIN_FLAG,
    ENABLE_OTP_LOGIN,
} from './constants';
import { getAppropriateProvider } from './utils/getAppropriateProvider';
import { SignInLoopError } from './utils/SignInLoopError';

export const zillowSignIn = async (options?: SignInOptions) => {
    dispatch(AUTH_EVENT_TYPES.LOGIN);
    const timeSinceLastLogin = trackFrequency(FREQUENCY_TRACKED_EVENTS.SIGN_IN_ATTEMPT);
    if (timeSinceLastLogin < MINIMUM_EXPECTED_FREQUENCY_SINCE_LAST_SIGN_IN) {
        const error = new SignInLoopError();
        const { datadog } = await import(
            /* webpackChunkName: "datadog" */
            'src/services/datadog'
        );
        datadog.addError(error, {
            timeSinceLastLogin,
        });
    }
    const provider = getAppropriateProvider();

    setSessionStorageItem(LOCATION_REQUESTED_SESSION_STORAGE_KEY, window.location.pathname);

    setTimeout(() => {
        // defer sign-in long enough for the dispatch to propagate
        signIn(provider, options, {
            [SUPPORTED_LOGIN_FLAG]: ENABLE_OTP_LOGIN,
        });
    }, 250);
};
